export default "__VITE_ASSET__BL7CpxHT__"